
const FuelExpenseTable = ({ isReadOnly = false, fuelSettlementMode, fuelExpenseData = {}, setfuelExpenseData = () => { } }) => {

    const handleChange = (field, value) => {
        setfuelExpenseData((prev) => ({
            ...prev,
            fuelExpenseData: {
                ...prev.fuelExpenseData,
                [field]: field.includes('fuelMethod') ? value : Number(value),
            },
        }));
    }

    const rows = [
        { label: "Reserve Internal Qty Total", keys: ["reserveInternalQtyHsfo", "reserveInternalQtyLsfo", "reserveInternalQtyMgo"] },
        { label: "Reserve Internal Cost", keys: ["reserveInternalCostHsfo", "reserveInternalCostLsfo", "reserveInternalCostMgo"] },
        { label: "Trip Supply Qty", keys: ["tripSupplyQtyHsfo", "tripSupplyQtyLsfo", "tripSupplyQtyMgo"] },
        { label: "Voyage Consumption Qty", keys: ["voyageConsumptionQtyHsfo", "voyageConsumptionQtyLsfo", "voyageConsumptionQtyMgo"] },
    ];

    const commonRows = [
        { label: "Shortage Qty", keys: ["shortageQtyHsfo", "shortageQtyLsfo", "shortageQtyMgo"] },
        { label: "Excess Qty", keys: ["excessQtyHsfo", "excessQtyLsfo", "excessQtyMgo"], className: "font-bold text-slate-900" },
    ];

    const redeliveryRows = [
        { label: "Voyage Fuel Expenditure", keys: ["voyageFuelExpenditureHsfo", "voyageFuelExpenditureLsfo", "voyageFuelExpenditureMgo"] },
        { label: "Fuel Settlement Profit", keys: ["fuelSettlementProfitHsfo", "fuelSettlementProfitLsfo", "fuelSettlementProfitMgo"] },
        { label: "Qty Balance On board", keys: ["qtyBalanceOnboardHsfo", "qtyBalanceOnboardLsfo", "qtyBalanceOnboardMgo"] },
        { label: "Delivery Prices", keys: ["deliveryPricesHsfo", "deliveryPricesLsfo", "deliveryPricesMgo"] },
    ];

    const relayRows = [
        { isHeader: true, label: "Shortage Case:" },
        { label: "Voyage Fuel Expenditure", keys: ["voyageFuelExpenditureHsfo", "voyageFuelExpenditureLsfo", "voyageFuelExpenditureMgo"] },
        { isHeader: true, label: "Excess Case:" },
        { label: "Fuel Settlement Profit", keys: ["fuelSettlementProfitHsfo", "fuelSettlementProfitLsfo", "fuelSettlementProfitMgo"] },
    ];

    return (
        <div className="max-w-5xl mx-auto space-y-3 text-[11px]">
            {/* Top Reserve External Table */}
            <div className="rounded-none border border-[#cbd5e1] overflow-hidden bg-white">
                <div className="overflow-x-auto scroll-thin">
                    <table className="w-full text-[11px] font-medium border-collapse">
                        <thead className="bg-[#e2e8f0] text-[#1e293b] h-[24px]">
                            <tr>
                                <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-r border-b border-[#cbd5e1] w-1/3"></th>
                                <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-r border-b border-[#cbd5e1]">HSFO (Main)</th>
                                <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-r border-b border-[#cbd5e1]">LSFO (ECA)</th>
                                <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-b border-[#cbd5e1]">MGO (Light Fuel)</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {[{ keys: ["reserveExternalQtyHsfo", "reserveExternalQtyLsfo", "reserveExternalQtyMgo"] }].map((row, idx) => (
                                <tr key={idx} className="h-[20px] hover:bg-amber-50/50 transition-colors">
                                    <td className="px-2.5 py-0.5 font-medium text-slate-800 border-r border-b border-[#cbd5e1] align-middle">Reserve External Qty Total</td>
                                    {row.keys.map((key, i) => (
                                        <td key={i} className={`px-2.5 py-0.5 text-slate-900 font-medium border-b border-[#cbd5e1] bg-[#f0f4f9] align-middle ${i < 2 ? "border-r" : ""}`}>{fuelExpenseData[key] || 0}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Main Calculation Table */}
            <div className="rounded-none border border-[#cbd5e1] overflow-hidden bg-white">
                <div className="overflow-x-auto scroll-thin">
                    <table className="w-full text-[11px] font-medium border-collapse">
                        <thead className="bg-[#e2e8f0] text-[#1e293b] h-[24px]">
                            <tr>
                                <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-r border-b border-[#cbd5e1] w-1/3"></th>
                                <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-r border-b border-[#cbd5e1]">HSFO (Main)</th>
                                <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-r border-b border-[#cbd5e1]">LSFO (ECA)</th>
                                <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-b border-[#cbd5e1]">MGO (Light Fuel)</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {/* Fuel Calculation Method - Editable */}
                            <tr className="h-[20px] bg-[#ffffd6]/40 hover:bg-[#ffffd6]/70 transition-colors">
                                <td className="px-2.5 py-0.5 font-medium text-slate-800 border-r border-b border-[#cbd5e1] align-middle text-[11px] capitalize">Fuel Calculation Method</td>
                                <td className="p-0 border-r border-b border-[#cbd5e1] bg-[#ffffd6] h-[20px] align-middle">
                                    <select
                                        disabled={isReadOnly}
                                        value={fuelExpenseData.fuelMethodHsfo || "LIFO"}
                                        onChange={(e) => handleChange("fuelMethodHsfo", e.target.value)}
                                        className="w-full h-full text-[11px] px-1.5 py-0 border-none outline-none font-medium bg-[#ffffd6] text-slate-900 focus:bg-white focus:ring-1 focus:ring-inset focus:ring-amber-500 cursor-pointer capitalize"
                                    >
                                        <option value="Average">Average</option>
                                        <option value="LIFO">LIFO</option>
                                        <option value="FIFO">FIFO</option>
                                    </select>
                                </td>
                                <td className="p-0 border-r border-b border-[#cbd5e1] bg-[#ffffd6] h-[20px] align-middle">
                                    <select
                                        disabled={isReadOnly}
                                        value={fuelExpenseData.fuelMethodLsfo || "LIFO"}
                                        onChange={(e) => handleChange("fuelMethodLsfo", e.target.value)}
                                        className="w-full h-full text-[11px] px-1.5 py-0 border-none outline-none font-medium bg-[#ffffd6] text-slate-900 focus:bg-white focus:ring-1 focus:ring-inset focus:ring-amber-500 cursor-pointer capitalize"
                                    >
                                        <option value="Average">Average</option>
                                        <option value="LIFO">LIFO</option>
                                        <option value="FIFO">FIFO</option>
                                    </select>
                                </td>
                                <td className="p-0 border-b border-[#cbd5e1] bg-[#ffffd6] h-[20px] align-middle">
                                    <select
                                        disabled={isReadOnly}
                                        value={fuelExpenseData.fuelMethodMgo || "LIFO"}
                                        onChange={(e) => handleChange("fuelMethodMgo", e.target.value)}
                                        className="w-full h-full text-[11px] px-1.5 py-0 border-none outline-none font-medium bg-[#ffffd6] text-slate-900 focus:bg-white focus:ring-1 focus:ring-inset focus:ring-amber-500 cursor-pointer capitalize"
                                    >
                                        <option value="Average">Average</option>
                                        <option value="LIFO">LIFO</option>
                                        <option value="FIFO">FIFO</option>
                                    </select>
                                </td>
                            </tr>

                            {rows.map((row, idx) => (
                                <tr key={idx} className="h-[20px] hover:bg-amber-50/50 transition-colors">
                                    <td className="px-2.5 py-0.5 font-medium text-slate-800 border-r border-b border-[#cbd5e1] align-middle text-[11px] capitalize">{row.label}</td>
                                    {row.keys.map((key, i) => (
                                        <td key={i} className={`px-2.5 py-0.5 text-slate-800 font-medium border-b border-[#cbd5e1] align-middle text-[11px] ${i < 2 ? "border-r" : ""}`}>{fuelExpenseData[key] || 0}</td>
                                    ))}
                                </tr>
                            ))}

                            {/* PMT Price for Shortfall - Editable */}
                            <tr className="h-[20px] bg-[#ffffd6]/40 hover:bg-[#ffffd6]/70 transition-colors">
                                <td className="px-2.5 py-0.5 font-medium text-slate-800 border-r border-b border-[#cbd5e1] align-middle text-[11px] capitalize">PMT Price for Shortfall</td>
                                {["hsfoShortfall", "lsfoShortfall", "mgoShortfall"].map((key, i) => (
                                    <td key={key} className={`p-0 border-b border-[#cbd5e1] bg-[#ffffd6] h-[20px] align-middle ${i < 2 ? "border-r" : ""}`}>
                                        <input
                                            type="number"
                                            step="0.1"
                                            disabled={isReadOnly}
                                            value={fuelExpenseData[key] || 0}
                                            onChange={(e) => handleChange(key, e.target.value)}
                                            className="w-full h-full text-[11px] px-1.5 py-0 border-none outline-none font-medium bg-[#ffffd6] text-slate-900 focus:bg-white focus:ring-1 focus:ring-inset focus:ring-amber-500 text-right tabular-nums"
                                        />
                                    </td>
                                ))}
                            </tr>

                            {/* PMT Prices for Excess - Editable */}
                            <tr className="h-[20px] bg-[#ffffd6]/40 hover:bg-[#ffffd6]/70 transition-colors">
                                <td className="px-2.5 py-0.5 font-medium text-slate-800 border-r border-b border-[#cbd5e1] align-middle text-[11px] capitalize">PMT Prices for Excess</td>
                                {["hsfoExcess", "lsfoExcess", "mgoExcess"].map((key, i) => (
                                    <td key={key} className={`p-0 border-b border-[#cbd5e1] bg-[#ffffd6] h-[20px] align-middle ${i < 2 ? "border-r" : ""}`}>
                                        <input
                                            type="number"
                                            step="0.1"
                                            disabled={isReadOnly}
                                            value={fuelExpenseData[key] || 0}
                                            onChange={(e) => handleChange(key, e.target.value)}
                                            className="w-full h-full text-[11px] px-1.5 py-0 border-none outline-none font-medium bg-[#ffffd6] text-slate-900 focus:bg-white focus:ring-1 focus:ring-inset focus:ring-amber-500 text-right tabular-nums"
                                        />
                                    </td>
                                ))}
                            </tr>

                            {commonRows.map((row, idx) => (
                                <tr key={idx} className="h-[20px] hover:bg-amber-50/50 transition-colors">
                                    <td className="px-2.5 py-0.5 font-medium text-slate-800 border-r border-b border-[#cbd5e1] align-middle">{row.label}</td>
                                    {row.keys.map((key, i) => (
                                        <td key={i} className={`px-2.5 py-0.5 text-slate-800 font-medium border-b border-[#cbd5e1] align-middle ${i < 2 ? "border-r" : ""}`}>
                                            {fuelExpenseData[key] || 0}
                                        </td>
                                    ))}
                                </tr>
                            ))}

                            {fuelSettlementMode === "relay" &&
                                redeliveryRows.map((row, idx) => (
                                    <tr key={`relay-${idx}`} className="h-[20px] hover:bg-amber-50/50 transition-colors">
                                        <td className="px-2.5 py-0.5 font-medium text-slate-800 border-r border-b border-[#cbd5e1] align-middle">{row.label}</td>
                                        {row.keys.map((key, i) => (
                                            <td key={i} className={`px-2.5 py-0.5 text-slate-800 font-medium border-b border-[#cbd5e1] align-middle ${i < 2 ? "border-r" : ""}`}>
                                                {fuelExpenseData[key] || 0}
                                            </td>
                                        ))}
                                    </tr>
                                ))}

                            {fuelSettlementMode === "redelivery" &&
                                relayRows.map((row, idx) => {
                                    if (row.isHeader) {
                                        return (
                                            <tr key={`redelivery-header-${idx}`} className="bg-[#e2e8f0] border-b border-[#cbd5e1]">
                                                <td colSpan="4" className="px-2.5 py-1 font-medium capitalize tracking-wider text-[11px] text-[#1e293b]">{row.label}</td>
                                            </tr>
                                        );
                                    }
                                    return (
                                        <tr key={`relay-${idx}`} className="h-[20px] hover:bg-amber-50/50 transition-colors">
                                            <td className="px-2.5 py-0.5 font-medium text-slate-800 border-r border-b border-[#cbd5e1] align-middle">{row.label}</td>
                                            {row.keys.map((key, i) => (
                                                <td key={i} className={`px-2.5 py-0.5 text-slate-800 font-medium border-b border-[#cbd5e1] align-middle ${i < 2 ? "border-r" : ""}`}>
                                                    {fuelExpenseData[key] || 0}
                                                </td>
                                            ))}
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default FuelExpenseTable;